import { envConfig } from "@configs/env";
import { DeployCountry } from "@types";
import { PreloadableComponent, lazyWithPreload } from "@utils/lazyWithPreload";
import { ComponentType } from "react";

/**
 * Utility function to get a country-specific component using React.lazy()
 *
 * @param componentMap - Record mapping DeployCountry to dynamic import functions
 * @param currentCountry - The current country to get the component for
 * @returns A lazy-loaded component for the specified country
 * @throws Error if no component is defined for the current country
 */
export function getCountryComponent<P extends object>(
  componentMap: Record<DeployCountry, () => Promise<{ default: ComponentType<P> }>>,
  currentCountry = envConfig.countryCode,
): PreloadableComponent<ComponentType<P>> {
  const importFn = componentMap[currentCountry];

  if (!importFn) {
    throw new Error(`No component defined for country: ${currentCountry}`);
  }

  return lazyWithPreload(importFn);
}
